module.exports = __webpack_public_path__ + "static/img/user-menu-2.f53417be.png";